export default function UseCaseBadge({ label, variant = "outline" }) {
  if (variant === "filled") {
    return (
      <span className="inline-flex items-center px-2.5 sm:px-3 py-1 rounded-full text-[10px] sm:text-[11px] font-medium uppercase tracking-wide font-mono bg-navy text-white max-w-full">
        {label}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center px-2.5 sm:px-3 py-1 rounded-full text-[10px] sm:text-[11px] font-medium uppercase tracking-wide font-mono text-teal border border-teal max-w-full text-center">
      {label}
    </span>
  );
}
